// extracted by mini-css-extract-plugin
export default {"taskPage":"EmployeeTasks_taskPage__uUPFG","breadcrumb":"EmployeeTasks_breadcrumb__EGcLP"};